import { render, staticRenderFns } from "./step_general_data.vue?vue&type=template&id=01ffb0e4&scoped=true"
import script from "./step_general_data.vue?vue&type=script&lang=js"
export * from "./step_general_data.vue?vue&type=script&lang=js"
import style0 from "./step_general_data.vue?vue&type=style&index=0&id=01ffb0e4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ffb0e4",
  null
  
)

export default component.exports